<template>
    <v-dialog width="70%" v-model="dialogControl">
        <v-card class="dialog-card" style="border-radius: 10px;">
            <v-card-title class="headline justify-center grey lighten-2">
                <h2>Daily Deals</h2>
                <v-btn @click="dialogControl = false" class="top-right-close-btn" icon>
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-flex class="inner-card-flex">
                <v-row>
                    <v-col>M</v-col>
                    <v-col>Tu</v-col>
                    <v-col>W</v-col>
                    <v-col>Th</v-col>
                </v-row>
                <v-row>
                    <v-col v-for="i in 4" :key="i" class="center">
                        <deal-card v-if="getMorningDeal(i)" :deal="getMorningDeal(i)" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-for="i in 4" :key="i" class="center">
                        <deal-card v-if="getNoonDeal(i)" :deal="getNoonDeal(i)" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-for="i in 4" :key="i" class="center">
                        <deal-card v-if="getEveningDeal(i)" :deal="getEveningDeal(i)" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>F</v-col>
                    <v-col>Sa</v-col>
                    <v-col>Su</v-col>
                </v-row>
                <v-row>
                    <v-col v-for="i in 4" :key="i" class="center">
                        <deal-card v-if="getMorningDeal(i + 4)" :deal="getMorningDeal(i + 4)" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-for="i in 3" :key="i" class="center">
                        <deal-card v-if="getNoonDeal(i + 4)" :deal="getNoonDeal(i + 4)" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-for="i in 3" :key="i" class="center">
                        <deal-card v-if="getEveningDeal(i + 4)" :deal="getEveningDeal(i + 4)" />
                    </v-col>
                </v-row>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
import DealCard from './DealTableCard'
import moment from 'moment'

export default {
    name: 'daily-deal-dialog',
    components: {
        'deal-card': DealCard,
    },
    props: {
        deals: {
            type: Array,
            defualt: () => [],
        },
        showDialog: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getMorningDeal(day) {
            return this.morningDeals.find(s => s.day == day)
        },
        getNoonDeal(day) {
            return this.noonDeals.find(s => s.day == day)
        },
        getEveningDeal(day) {
            return this.eveningDeals.find(s => s.day == day)
        },
    },
    computed: {
        dialogControl: {
            get() {
                return this.showDialog
            },
            set(newVal) {
                this.$emit('set-dialog-control', newVal)
            },
        },
        morningDeals() {
            return this.deals.filter(d => moment(d.start).hour() <= 11)
        },
        noonDeals() {
            return this.deals.filter(d => moment(d.start).hour() > 11 && moment(d.start).hour() <= 17)
        },
        eveningDeals() {
            return this.deals.filter(d => moment(d.start).hour() > 17 && moment(d.start).hour() <= 23)
        },
    },
}
</script>